import { useSelector } from 'react-redux'

import { AuthState, RootState } from '@/store'

export default (): AuthState => useSelector((state: RootState) => state.auth)
